import { defineStore } from 'pinia'

export const useUserAddressStore = defineStore('userAddressStore', () => {
  const { API_ENDPOINTS } = useApiEndpoints()
  const locationStore = useLocationStore()
  
  const isOpenAddressModal = ref(false)
  const openAllAddressModal = ref(false)
  const loading = ref(false)
  const editingAddress = ref(null)
  
  let newAddress = ref({
    title: '',
    name: '',
    last_name: '',
    phone: '',
    address: '',
    city_id: '',
    district_id: '',
    email: '',
    is_default: true,
    address_type: 'shipping'
  })

  const copyNewAddress = toRaw({ ...newAddress.value })

  const addresses = ref([])

  const defaultAddress = computed(() => {
    let filteredAddresses = addresses.value?.filter(
      (address) => address.isDefault === true
    )
    return filteredAddresses.length ? filteredAddresses[0] : null
  })

  const saveAddress = async (item) => {
    loading.value = true
    console.log('Store saveAddress başladı:', item)
    try {
      const response = await useBaseOFetchWithAuth(API_ENDPOINTS.anonymous.addresses.save, {
        method: 'POST',
        body: JSON.stringify(item)
      })
      console.log('Store saveAddress response:', response)

      await fetchAddresses()
      isOpenAddressModal.value = false
      editingAddress.value = null
      return true
    } catch(error) {
      console.error('Adres kaydetme hatası:', error)
      return false
    } finally {
      loading.value = false
    }
  }

  const setDefaultAddress = async (address) => {
    address.loading = true
    try {
      await useBaseOFetchWithAuth(API_ENDPOINTS.anonymous.addresses.setDefault, {
        method: 'POST',
        body: JSON.stringify({ addressId: address.id })
      })
      
      await fetchAddresses()
      return true
    } catch(error) {
      console.error('Varsayılan adres ayarlama hatası:', error)
      return false
    } finally {
      address.loading = false
    }
  }

  const deleteAddress = async (id) => {
    loading.value = true
    try {
      const response = await useBaseOFetchWithAuth(
        API_ENDPOINTS.anonymous.addresses.delete(id),
        {
          method: 'DELETE'
        }
      )

      if (!response.error) {
        addresses.value = addresses.value.filter((address) => address.id !== id)
        return true
      }
      return false
    } catch(error) {
      console.error('Adres silme hatası:', error)
      return false
    } finally {
      loading.value = false
    }
  }

  const updateAddress = async (address) => {
    loading.value = true
    console.log('Store updateAddress başladı:', address)
    try {
      const response = await useBaseOFetchWithAuth(
        API_ENDPOINTS.anonymous.addresses.update(address.id),
        {
          method: 'PUT',
          body: JSON.stringify(address)
        }
      )
      console.log('Store updateAddress response:', response)

      await fetchAddresses()
      isOpenAddressModal.value = false
      editingAddress.value = null
      return true
    } catch(error) {
      console.error('Adres güncelleme hatası:', error)
      return false
    } finally {
      loading.value = false
    }
  }

  const fetchAddresses = async () => {
    loading.value = true
    try {
      const response = await useBaseOFetchWithAuth(
        API_ENDPOINTS.anonymous.addresses.list
      )
      addresses.value = response
    } finally {
      loading.value = false
    }
  }

  // Modal kapandığında formu sıfırla
  watch(isOpenAddressModal, () => {
    if (!isOpenAddressModal.value) {
      newAddress.value = { ...copyNewAddress }
      editingAddress.value = null
    }
  })

  return {
    addresses,
    defaultAddress,
    newAddress,
    editingAddress,
    isOpenAddressModal,
    openAllAddressModal,
    fetchAddresses,
    setDefaultAddress,
    saveAddress,
    deleteAddress,
    updateAddress,
    loading
  }
}) 